// ignore-string-externalization
import type { ErrorEvent, SeverityLevel } from '@sentry/types';

export type KnownIssue = {
  id: string;
  description: string;
  resolvedBy: string;
  match: (event: ErrorEvent) => boolean;
  level: SeverityLevel;
};

export const knownIssues: KnownIssue[] = [
  {
    id: 'stylis-stack-overflow',
    description:
      'styled-components stylis CSS serialization overflows the call stack on iOS devices ' +
      'with limited stack depth. Root cause is recursive AST traversal in stylis ' +
      'serialize/stringify — not an infinite loop, just too deep for iOS WebKit.',
    resolvedBy:
      'Upgrade to styled-components v7 (replaces stylis with a non-recursive parser). ' +
      'Remove this entry and the @sentry/types dev dependency when resolved.',
    level: 'warning',
    // Frame-level analysis is not possible: the Sentry SDK drops stack
    // lines longer than 1024 chars (STACKTRACE_FRAME_LIMIT in
    // @sentry/utils/stacktrace.js), and every frame in these minified
    // bundles exceeds that. The frames array is empty in beforeSend.
    match(event) {
      const ex = event.exception?.values?.[0];
      return /Maximum call stack size exceeded/.test(ex?.value ?? '');
    },
  },
];
